<template>
  <div class="parking-data">
    <div class="parking-data__description" v-html="descriptionTop"></div>
    <br>
    <div class="parking-data__zone">
      {{ zoneId }}
    </div>
    <div class="parking-data__description" v-html="zoneDesc"></div>
  </div>
</template>

<script lang="ts">
import store from '@/store';
import {
  defineComponent, onMounted, Ref, ref,
} from 'vue';

const TemplateModalParkingMeter: object = defineComponent({
  props: {
    templateData: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const descriptionTop: Ref<string> = ref('');
    const zoneId: Ref<string> = ref('');
    const zones = store.state.parkingZones.features;
    const zoneDesc: Ref<string> = ref('');

    onMounted(() => {
      const { metaData } = props.templateData;
      descriptionTop.value = metaData.description || '';
      zoneId.value = metaData.zone_id || '';

      console.log('Zones from store:', zones);

      const matchedZone = zones.find((zone: any) => zone.properties.id == zoneId.value);

      console.log('Matched zone:', matchedZone);
      zoneDesc.value = matchedZone?.properties?.description || '';
    });

    return {
      descriptionTop,
      zoneId,
      zoneDesc,
    };
  },
});
export default TemplateModalParkingMeter;
</script>
